@if (levelConfigForm) {
  <div class="levelConfigForm">
    <form [formGroup]="levelConfigForm">
      <h4>Chief's Order Level Configuration</h4>
      <div class="chiefsOrderInputContainer">
        <label>
          Category
          <select formControlName="category" (change)="getData()">
            @for (category of activeCategories; track category) {
              <option [value]="category.Code">
                {{ category.Definition }}
              </option>
            }
          </select>
        </label>
      </div>
      <div class="chiefsOrderInputContainer">
        <label>
          Level Number (1 -10)
          <select formControlName="level" (change)="uniqueLevelNum()">
            @for (num of levelNumbers; track num) {
              <option [value]="num">
                {{ num }}
              </option>
            }
          </select>
        </label>
      </div>
      <div class="fullWidthChiefsOrderInputContainer">
        <label>
          <input type="checkbox" (click)="toggleHideGroupAssignment()" formControlName="canSelectAssignToGroup">
          Can select the group to assign to at time of review.
        </label>
      </div>
      @if (!hideGroupAssignment) {
        <div class="chiefsOrderInputContainer">
          <label>
            Assign To
            <select formControlName="assignTo">
              @for (group of activeGroups; track group) {
                <option value="{{group.id}}">{{group.displayName}}</option>
              }
            </select>
          </label>
        </div>
        <div class="chiefsOrderInputContainer">
          <label>
            Return To
            <select multiple formControlName="returnTo">
              @for (group of activeGroups; track group) {
                <option value="{{group.id}}">{{group.displayName}}</option>
              }
            </select>
          </label>
        </div>
      }
      <div class="chiefsOrderInputContainer">
        <div>Mode</div>
        <label>
          <input type="radio" formControlName="mode" value="initiator">
          Initiator Confirmation
        </label>
        <label>
          <input type="radio" formControlName="mode" value="chief">
          Chief Level
        </label>
        <label>
          <input type="radio" formControlName="mode" value="neither">
          Neither
        </label>
        <label>
          <input type="checkbox" formControlName="canReject" value="">
          Can reject chief's order
        </label>
      </div>
      <div class="chiefsOrderInputContainer">
        <p>
          The known strings that will be replaced in a notification are:<br />
          'AppName' will be replaced with the report template name<br />
          'CONumber' will be replaced with the chief's order number<br />
          'AppNum' will be replaced with the chief's order application number
        </p>
        <label>
          Notification
          <textarea formControlName="notification" rows="2" name="notification" placeholder="add notification text"></textarea>
        </label>
      </div>
      <button class="button addLevelButton" [disabled]="!isFormValid()" (click)="addLevel()">Add Level</button>
    </form>
  </div>
}
<div class="gridContainer levelConfigTable">
  <ag-grid-angular [gridOptions]="gridOptions" [rowData]="coLevels" class="data-grid " aria-label="Co Level Config"></ag-grid-angular>
</div>
